// import { Code, Server, Layers } from "lucide-react"

interface Framework {
  name: string
  description: string
}

interface FrameworkSectionProps {
  languages: Framework[]
}

export default function FrameworkSection({ languages }: FrameworkSectionProps) {


  return (
    <div className="mb-16 mx-2 md:w-1/2 w-full">
      <div className="bg-background border border-turquoise/10 rounded-xl p-6 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute inset-[1px] rounded-xl [background:linear-gradient(45deg,#0a0a0a,theme(colors.background)_50%,#0a0a0a)_padding-box,conic-gradient(from_var(--border-angle),theme(colors.contentBorder)_80%,_theme(colors.turquoise.DEFAULT)_86%,_theme(colors.turquoise.light)_90%,_theme(colors.turquoise.DEFAULT)_94%,_theme(colors.contentBorder))_border-box] border border-transparent animate-border"></div>
        </div>

        <div className="relative z-10 space-y-6 max-h-[410px] overflow-scroll">
          {languages.map((language, index) => (
            <div key={index} className="flex flex-col">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <h4 className="text-md font-medium text-text">{language.name}</h4>
                </div>
              </div>
              <div aria-hidden className='mb-3 bg-[#ffffff33] min-h-[1px] w-full'></div>
              <p className="text-gray-300 text-sm">{language.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

